import { Schema } from "effect";

export const HealthResponse = Schema.Struct({
  status: Schema.Literal("ok"),
  timestamp: Schema.Number,
  message: Schema.optional(Schema.String),
});

export type HealthResponse = typeof HealthResponse.Type;

export const HealthRequest = Schema.Struct({
  message: Schema.optional(Schema.String),
});

export type HealthRequest = typeof HealthRequest.Type;
